module.exports = __webpack_public_path__ + "static/mujeres008.thumb-6bd448c6ce436d4d098c27e84e6c97c5.jpg";